<script>
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import InputField from './InputField.vue';
import ColorPicker from './ColorPicker.vue';
import AppButton from './AppButton.vue';
import { crossIcon, loadingLgIcon, arrowUpFilled, arrowDownFilled } from '@/utils/proposalIcons';
import {api_baseURL} from "@/utils/init.js";
// Configure PDF.js worker - using legacy build
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/legacy/build/pdf.worker.min.js`;

//import { GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
//import pdfWorker from 'pdfjs-dist/build/pdf.worker.min.js';
//GlobalWorkerOptions.workerSrc = pdfWorker;



export default {
    name: "ManagePagesModal",
    components: {
        InputField,
        ColorPicker,
        AppButton,
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        proposal: {
            type: Object,
            required: true
        },
        sectionsReadiness: {
            type: Object,
            required: true
        },
		steps:{type: Array,
		       required: true
		}
    },
    data() {
        return {
            convertingFile: false,
            currentUploadPosition: null,
            localProposal: JSON.parse(JSON.stringify(this.proposal)),
            crossIcon,
            loadingLgIcon,
            arrowUpFilled,
            arrowDownFilled
        };
    },
	created() {},
    computed: {
        activeModal() {
            return this.show;
        },
        visibleSections() {
            const order = this.localProposal.sectionOrder || ['orgChart', 'resume', 'comparable', 'approach'];
            return order.filter(key => this.isSectionVisible(key));
        }
    },
    watch: {
        proposal: {
            handler(newVal) {
                if (this.show) return;
                this.localProposal = JSON.parse(JSON.stringify(newVal));
                if (!this.localProposal.customPages) {
                    this.localProposal.customPages = [];
                }
                if (!this.localProposal.sectionOrder) {
                    this.localProposal.sectionOrder = ['orgChart', 'resume', 'comparable', 'approach'];
                }
            },
            deep: true,
            immediate: true
        },
        show(isOpen) {
            if (isOpen) {
                this.localProposal = JSON.parse(JSON.stringify(this.proposal));
                if (!this.localProposal.customPages) {
                    this.localProposal.customPages = [];
                }
                if (!this.localProposal.sectionOrder) {
                    this.localProposal.sectionOrder = ['orgChart', 'resume', 'comparable', 'approach'];
                }
            }
        }
    },
    methods: {
        getSectionTitle(key) {
            const titles = {
                orgChart: (this.localProposal && this.localProposal.orgChart && this.localProposal.orgChart.title) || "Organizational Chart",
                resume: (this.localProposal && this.localProposal.resume && this.localProposal.resume.title) || "Members Resume",
                comparable: (this.localProposal && this.localProposal.comparable && this.localProposal.comparable.title) || "Comparable Projects",
                approach: (this.localProposal && this.localProposal.approach && this.localProposal.approach.title) || "Project Questions"
            };
            return titles[key] || key;
        },
        isSectionVisible(key) {
            if (key === 'frontPage') return this.sectionsReadiness.frontPage;
            if (key === 'toc') return this.sectionsReadiness.toc;
            if (key === 'orgChart') return this.sectionsReadiness.orgChart;
            if (key === 'resume') return this.sectionsReadiness.resume;
            if (key === 'comparable') return this.sectionsReadiness.comparable;
            if (key === 'approach') return this.sectionsReadiness.approach;
            if (key === 'lastPage') return this.sectionsReadiness.lastPage;
            return false;
        },
        handleMoveSection(from, to) {
            const visible = this.visibleSections;
            const keyFrom = visible[from];
            const keyTo = visible[to];

            const order = [...this.localProposal.sectionOrder];
            const realIndexFrom = order.indexOf(keyFrom);
            const realIndexTo = order.indexOf(keyTo);

            if (realIndexFrom !== -1 && realIndexTo !== -1) {
                const item = order.splice(realIndexFrom, 1)[0];
                order.splice(realIndexTo, 0, item);
                this.localProposal.sectionOrder = order;
            }
        },
        getFilesForPosition(position) {
            return (this.localProposal.customPages || []).filter((file) => file.position === position);
        },
        triggerFileUpload(position) {
            this.currentUploadPosition = position;
            if (this.$refs.fileInput) this.$refs.fileInput.click();
        },
        async convertPDFToImages(file) {
            try {
                this.convertingFile = true;
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                const images = [];

                for (let i = 1; i <= pdf.numPages; i++) {
                    const page = await pdf.getPage(i);
                    const viewport = page.getViewport({ scale: 2.0 });
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;

                    await page.render({
                        canvasContext: context,
                        viewport: viewport
                    }).promise;

                    images.push(canvas.toDataURL('image/png'));
                }
                return images;
            } catch (error) {
                throw error;
            } finally {
                this.convertingFile = false;
            }
        },
        async handleFileUpload(event) {
            const files = Array.from(event.target.files);
            for (const file of files) {
                const fileType = file.type;
                const isPDF = fileType === 'application/pdf';

                if (isPDF) {
                    try {
						const proposalFileId=Date.now();
						const files = file ? [file] : [];
						const fileName= await this.$store.dispatch("uploadProposalFile", {files: files, proposalFileId: proposalFileId});
                        
						if(!fileName) return;
						
                        const uploadedFile = {
                            id: proposalFileId,
							fileName:fileName,
                            name: file.name,
                            type: fileType,
                            preview: "",
                            data: "",
                            position: this.currentUploadPosition,
                            isPDF: true,
							noPages:this.m_getPageCount(file),
                            bannerTitle: file.name.split('.')[0],
                            bannerHeaderColor: (this.localProposal.style && this.localProposal.style.colorScheme && this.localProposal.style.colorScheme.header) || '#545454',
                            bannerFooterColor: (this.localProposal.style && this.localProposal.style.colorScheme && this.localProposal.style.colorScheme.footer) || '#545454'
                        };

                        if (!this.localProposal.customPages) {
                            this.localProposal.customPages = [];
                        }
                        this.localProposal.customPages.push(uploadedFile);
						const pdfClass=`extra-pages-${uploadedFile.id}`;
						var fileStep={key:uploadedFile.id,title:file.bannerTitle,type:"uploadedPdf", class:pdfClass, locked:false,validate: () => true};
						this.steps.splice(2, 0, fileStep);
						
                    } catch (error) {
                        console.error('Error reading file:', error);
                        alert(`Failed to upload ${file.name}`);
                    }
                } else {
                    alert(`Only PDF files are allowed. ${file.name} was skipped.`);
                }
            }
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
		removeUploadedFile(fileId) {
			if (!this.localProposal.customPages) return;
			const fileName = this.localProposal.customPages.filter( f => f.id == fileId)[0].fileName||null;
			// Remove from customPages
				this.localProposal.customPages = this.localProposal.customPages
				.filter( f => f.id !== fileId);
			// Remove from steps safely
			const index = this.steps.findIndex(s => s.key === fileId);
			if (index !== -1) {this.steps.splice(index, 1);}
			if(fileName) this.$store.dispatch("deleteProposalFile", {fileName:fileName});
		},
        moveUpFile(position, index) {
            if (index === 0) return;
            if (!this.localProposal.customPages) return;
            const positionFiles = this.getFilesForPosition(position);
            const itemFrom = positionFiles[index];
            const itemTo = positionFiles[index - 1];

            const realIndexFrom = this.localProposal.customPages.findIndex(f => f.id === itemFrom.id);
            const realIndexTo = this.localProposal.customPages.findIndex(f => f.id === itemTo.id);

            if (realIndexFrom !== -1 && realIndexTo !== -1) {
                const temp = this.localProposal.customPages[realIndexFrom];
                this.localProposal.customPages.splice(realIndexFrom, 1, this.localProposal.customPages[realIndexTo]);
                this.localProposal.customPages.splice(realIndexTo, 1, temp);
            }
        },
        moveDownFile(position, index) {
            const positionFiles = this.getFilesForPosition(position);
            if (index === positionFiles.length - 1) return;
            if (!this.localProposal.customPages) return;
            const itemFrom = positionFiles[index];
            const itemTo = positionFiles[index + 1];

            const realIndexFrom = this.localProposal.customPages.findIndex(f => f.id === itemFrom.id);
            const realIndexTo = this.localProposal.customPages.findIndex(f => f.id === itemTo.id);

            if (realIndexFrom !== -1 && realIndexTo !== -1) {
                const temp = this.localProposal.customPages[realIndexFrom];
                this.localProposal.customPages.splice(realIndexFrom, 1, this.localProposal.customPages[realIndexTo]);
                this.localProposal.customPages.splice(realIndexTo, 1, temp);
            }
        },
        saveAndClose() {
		
		    this.steps.forEach(s=>{ 
			                     if(s.type=='uploadedPdf') {
								  const pdfFile=this.localProposal.customPages.filter(p=>p.id==s.key)[0];
                                  s.title=pdfFile?.bannerTitle;
                                 }
                        });						
            this.$emit('updateProposal', {steps:this.steps,proposal:this.localProposal});
            this.$emit('close');
        },
        closeWithoutSaving() {
            this.$emit('close');
        },
		updateFile(id, key, value) {
			const file = this.files.find(f => f.id === id)
			if (!file) return
			this.$set(file, key, value)
		},
  async m_getPageCount(file) {
		    const arrayBuffer = await file.arrayBuffer();
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
		    return pdf.numPages;
		},
    }
};
</script>
<template>
    <b-modal :visible="activeModal" title="Upload PDF" centered scrollable size="lg"
        @hide="closeWithoutSaving" no-close-on-backdrop no-close-on-esc>
		
		<template #modal-header="{ close }">
			<h5>Upload PDF</h5>
			<span @click="close()" v-html="crossIcon" class="close-btn" />
        </template>
		
        <div class="manage-modal-body">
           

            <!-- Hidden file input -->
            <input ref="fileInput" type="file" accept=".pdf,application/pdf" multiple style="display: none"
                @change="handleFileUpload" />

  

            <!-- Fixed Cover section -->
            <div class="upload-area" @click="triggerFileUpload('toc')">
                <div v-if="convertingFile && currentUploadPosition === 'toc'" class="spinner-container">
                    <span class="export-spinner" v-html="loadingLgIcon" />
                    <p>Processing ...</p>
                </div>
                <div v-else>
                    <p class="upload-text">Click to upload Files</p>
                    <p class="upload-subtext">Only <strong>PDF</strong> files allowed</p>
                </div>
            </div>

            <!-- Files-->
            <div v-if="localProposal.customPages.length > 0" class="uploaded-files-list">
                <div class="file-list">
                    <div class="list-header">
                        <div class="header-col">Heading</div>
                        <div class="header-col">Header</div>
                        <div class="header-col">Footer</div>
                        <div class="header-col action-col"></div>
                    </div>
                    <div v-for="(file, index) in localProposal.customPages" :key="file.id" class="file-item">
                        
                        <div class="wrapper">
                            <InputField :modelValue="file.bannerTitle" @update:modelValue="file.bannerTitle = $event" />
                        </div>
                        <div class="wrapper">
                            <ColorPicker :modelValue="file.bannerHeaderColor"
                                @change="file.bannerHeaderColor = $event" />
                        </div>
                        <div class="wrapper">
                            <ColorPicker :modelValue="file.bannerFooterColor"
                                @change="file.bannerFooterColor = $event" />
                        </div>
                        <span @click="removeUploadedFile(file.id)" v-html="crossIcon" class="cancel-btn" />
                    </div>
                </div>
            </div>

  
        </div>

        <!-- Modal Footer -->
        <template #modal-footer>
            <div class="d-flex justify-content-end w-100">
                <AppButton variant="none" class="mr-2" @click="closeWithoutSaving">Cancel</AppButton>
                <AppButton variant="primary" :disabled="convertingFile" @click="saveAndClose">Save</AppButton>
            </div>
        </template>
		
    </b-modal>
</template>


<style scoped lang="scss">
.modal-intro {
    color: #666;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    background: #fafafa;

    .section-title {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
        color: #333;
    }
}

.fixed-section {
    padding-left: 25px;
    border-left: 4px solid #ddd;
}

.movable-section {
    border-left: 4px solid #4475b4;
}

.section-reorder-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .layers-btn {
        width: 14px;
        height: 10px;
        font-size: 10px;
        line-height: 1;
        color: #999;
        cursor: pointer;
        background: #f0f0f0;
        border: 1px solid #ddd;
        border-radius: 2px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1px 0;

        &:hover {
            color: #666;
            border-color: #999;
            background: #e8e8e8;
        }

        &:disabled {
            color: #ccc;
            border-color: #eee;
            background: #f8f8f8;
            cursor: not-allowed;
        }
    }
}

.upload-area {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ced4da;
    border-radius: 8px;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 10px;
    background: #f4f8fd;
    height: 60px;

    &:hover {
        border-color: #4475b4;
        background-color: #f8f9ff;
    }

    .spinner-container {
        text-align: center;

        .export-spinner {
            display: inline-block;
            animation: spin 1s linear infinite;
            color: #4475b4;
        }

        p {
            color: #4475b4;
            font-weight: 700;
            font-size: 14px;
            margin: 0;
        }

    }

    .upload-text {
        font-size: 14px;
        font-weight: 700;
        color: #495057;
        margin-bottom: 0px;
    }

    .upload-subtext {
        font-size: 11px;
        color: #6c757d;
        margin-bottom: 0px;
    }
}

.uploaded-files-list {

    .list-header {
        display: grid;
        grid-template-columns: auto 150px 150px 20px;
        gap: 5px;
        align-items: center;
        border-bottom: 1px solid #dee2e6;

        .header-col {
            font-size: 11px;
            color: #666;
            font-weight: 600;
        }

        @media (max-width: 991px) {
            grid-template-columns: auto 60px 60px 20px;
        }
    }

    .file-list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        background: #fafafa;
        border: 1px solid #dee2e6;
        padding: 5px;
        margin-bottom: 10px;
    }

    .file-item {
        display: grid;
        grid-template-columns: auto 150px 150px 20px;
        gap: 5px;
        align-items: center;

        @media (max-width: 991px) {
            grid-template-columns: auto 60px 60px 20px;
        }

        .wrapper {
            display: flex;
            flex-direction: column;
            width: 100%;

            .color-picker {
                :deep(.color-picker-trigger) {
                    .color-name {
                        @media (max-width: 991px) {
                            display: none;
                        }
                    }
                }
            }
        }

        .cancel-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 50%;
            background-color: transparent;
            color: red;
            border1: 1px solid #ddd;
			border: none;
            padding: 2px;
            width: 20px;
            height: 20px;
            transition: all 0.3s ease;

            &:hover {
                color: green;
                background1: #dc3545;
            }
        }
    }
}

.export-spinner {
    display: inline-block;
    animation: spin 1s linear infinite;
    color: #4475b4;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}.close-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  line-height: 1;
  border: none;
  background: transparent;
  color: red;
  &:hover {color:green; }
}
.b-modal-header {
  position: relative;
}
.manage-modal-body{min-height:300px;}
</style>
